/**
 * 권한 트리 레이아웃 — 편집 트리(PermissionTree)와 유효 권한 트리(EffectivePermissionTree)가
 * <b>같은 모양</b>이어야 한다. 두 화면이 위아래로 나란히 놓이므로 한 칸만 어긋나도 눈에 띈다.
 *
 * <h3>계층은 SubTreeLine 이 그린다</h3>
 * <p>들여쓰기 숫자가 아니라 {@link ../common/SubTreeLine} 의 ㄴ자 연결선이 부모-자식을 보여준다
 * (사이드바와 같은 컴포넌트). 선이 관계를 직접 그리므로 <b>단 간격은 좁아도 읽힌다</b> —
 * 한 단 = {@code inset + 14px} = 22px.
 *
 * <h3>화살표와 체크박스는 오른쪽</h3>
 * <p>펼침 화살표를 글자 <b>앞</b>에 두면 단마다 24px(아이콘 18 + gap 6)씩 먹어서, 3단만 내려가도
 * 트리가 화면 절반을 가로지른다. 사이드바처럼 오른쪽 끝으로 보내면 그 폭이 통째로 사라지고
 * 왼쪽은 순수하게 계층만 남는다. 덕분에 <b>단일권한 탭 행도 보정 없이</b> 탭 글자와 맞는다
 * (예전엔 없는 화살표 자리만큼 24px 를 따로 밀어줘야 했다).
 *
 * <p>체크박스는 글자 바로 옆에 둔다. 오른쪽 끝에 몰아두면 깊이 들어간 항목일수록 이름과
 * 체크박스 사이가 멀어져서 어느 줄을 켜는지 눈이 따라가기 어렵다.
 *
 * <pre>
 *   메일                          0/4  ⌄
 *     └ 관리                      0/2  ⌄
 *         └ 전체 메일 조회  ☐
 *             타인의 메일까지 모두 조회합니다
 *     └ 글로벌 차단 규칙 관리  ☐        ← 권한 1개짜리 탭은 한 단 접어서 탭 자리에
 * </pre>
 */

/** 도메인 행의 좌측 패딩 (MUI spacing, 1 = 8px). */
export const DOMAIN_ROW_PL = 0.5;

/**
 * 연결선의 좌측 오프셋 — 모든 단계에서 같은 값을 써서 계단 간격을 일정하게 유지한다.
 * 한 단 = 이 값 + SubTreeLine 의 항목 패딩 14px = 22px.
 */
export const TREE_INSET = "8px";

/** 모든 행의 우측 패딩 — 오른쪽 화살표/개수 레일이 깊이와 무관하게 정렬되려면 같아야 한다. */
export const ROW_PR = 0.5;

/** 체크박스 아이콘 크기(px). MUI 기본 small(20) 은 이 밀도의 트리에선 커 보인다. */
export const CHECKBOX_ICON = 17;

/** 펼침 화살표 크기(px) — 사이드바의 ExpandLess/More 와 같은 13. */
export const EXPAND_ICON = 13;

/** 체크박스 공통 sx — 크기와 여백을 두 트리가 함께 쓴다. */
export const checkboxSx = {
    p: 0,
    flexShrink: 0,
    "& .MuiSvgIcon-root": { fontSize: CHECKBOX_ICON },
};
